export default {
  title: 'Fatture',
  form: {
    auto_generate_invoices: {
      label: 'Genera fatture automaticamente',
    },
  },
  buttons: {
    save: 'Salva',
  },
  toasts: {
    failed_to_save_changes: 'Salvataggio delle modifiche non riuscito',
    changes_got_saved: 'Modifiche salvate',
  },
};
